var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"snackbar-container"},_vm._l((_vm.alerts),function(message){return _c('alert-message',_vm._b({key:message.id},'alert-message',message,false,true))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }